<template>
    <div class="table-list" >
        <template v-if="((typeof tournamentAllData.id === 'undefined') || (tournamentAllData.id < 0) || (typeof tournamentAllData.roundsCount === 'undefined'))" >
            <div class="alert alert-primary" role="alert">Nie ma aktywnego turnieju.</div>
        </template>
        <template v-else >
    
            <template v-if="((typeof tournamentAllData.players === 'undefined') || (tournamentAllData.players.length === 0))" >
                <div class="alert alert-primary" role="alert">Nie ustawiono zawodników biorących udział w turnieju.</div>
            </template>
            <template v-else >
    
    
                <div class="row table-list-header" >
                    <div class="col-1 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Lp." >Lp.</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" title="Zawodnik" >Zawodnik</div>
                    <div class="col" >
                        <div class="row" >
                            <div class="col d-flex align-items-center justify-content-center table-item table-header-item text-nowrap table-border-fix" title="Runda" >Runda</div>
                        </div>
                        <div class="row" >
                        <div v-for="(n, index) in tournamentAllData.roundsCount" :key="index" class="col d-flex align-items-center justify-content-center table-item table-border-fix" v-bind:title="'Runda' + n" >{{ n }}</div>
                        </div>
                    </div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item table-header-item" title="Wynik bez HC" ><span class="text-center word-wrap text-truncate w-100" >Wynik bez HC</span></div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item table-header-item" title="Wynik" ><span class="text-center word-wrap text-truncate w-100" >Wynik</span></div>
                </div>

    
                <div v-for="(player, index) in getSortedPlayersList" class="row" :key="index" >
                    <div class="col-1 d-flex align-items-center justify-content-center table-item text-nowrap" >{{ index + 1 }}</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-item" ><span class="text-center" >{{ player.name }}</span></div>
                    <div class="col" >
                        <div class="row" >

                            <template v-for="(n, rindex) in tournamentAllData.roundsCount" >

                                <template v-if= "(typeof player.results[rindex] !== 'undefined')" >

                                    <div class="col text-nowrap" :key="rindex" >
                                        <div class="row" >
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix">{{ (player.results[rindex].A !== 'undefined') ?  player.results[rindex].A : '0' }}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix" >{{ (player.results[rindex].B !== 'undefined') ?  player.results[rindex].B : '0' }}</div>
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix" style="color: var(--bs-form-valid-color)" >{{ (player.results[rindex].CD !== 'undefined') ?  player.results[rindex].CD : '0' }}</div>
                                        </div>
                                    </div>      
                                
                                </template>
                                <template v-else >

                                    <div class="col text-nowrap" :key="rindex" >
                                        <div class="row" >
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix">0</div>
                                        </div>
                                        <div class="row">
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix" >0</div>
                                            <div class="col d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix" style="color: var(--bs-form-valid-color)" >0</div>
                                        </div>
                                    </div>      

                                </template>

                            </template>
                    
                        </div>
                    </div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item" ><span class="text-center word-wrap text-truncate w-100" >{{ player.resultNoHC }}</span></div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item" ><span class="text-center word-wrap text-truncate w-100" >{{ player.result }}</span></div>
                </div>

            </template>
    
        </template>
    
    
    </div>
    </template>
    
    <style scoped>
    .table-list {
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
    }
    .table-list-header {
        border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
    }
    .table-list-header > .table-item:first-child {
        border-radius: var(--bs-border-radius) 0 0 0;
    }
    .table-list-header > .table-item:last-child {
        border-radius: 0 var(--bs-border-radius) 0 0;
    }
    .table-header-item {
        background-color: #F1F3F5;
    }
    .table-item {
        border: 1px solid #C7C8CA;
        margin: -1px 0 0 -1px;
    }
    .table-border-fix {
        border-width: 1px 0 1px 1px;
    }
    </style>
    
    <script>
    export default {
        name: 'panel-results-list',
        data: function() {
            return {}
        },
        props: {
            tournamentAllData: {
                type: Object,
                required: true,
            }
        },
        computed: {
            getSortedPlayersList: function() {
                let list = [];
                if (typeof this.tournamentAllData.players === 'undefined') {
                    return list;
                }
                list = JSON.parse(JSON.stringify(this.tournamentAllData.players));
                list.sort((a, b) => {
                    if (a.result > b.result) {
                        return -1;
                    }
                    if (a.result < b.result) {
                        return 1;
                    }
                    if (a.extra > b.extra) {
                        return -1;
                    }
                    if (a.extra < b.extra) {
                        return 1;
                    }                        
                    return 0;
                });
    
                return list;
            }             
        },
        methods: {
        },
        mounted: function() {
            console.log('component panel-results-list mounted')
        }
    };      
    </script>